<template>
    <div class="row panel-body">
            <div class="row">
                <div class="col-xs-1">

                </div>
                <div class="col-xs-3">
                    <h4 style="padding-left: 5px;">Master</h4>
                </div>

                <div class="col-xs-3">
                    <h4 style="padding-left: 5px;">Correction</h4>
                </div>

                <div class="col-xs-5">
                    <h4 style="padding-left: 5px;">Translation</h4>
                </div>
            </div>

            <subtitle-translation-correction-cue
                    v-for="(cue, number) in originalCues"
                    :number="number"
                    :key="number"
                    :original-lines="cue"
                    :corrected-lines="correctedCues[number]"
                    :translated-lines="translatedCues[number]"
                    :locked="isLocked(number)">
            </subtitle-translation-correction-cue>

            <div class="row">
                <div class="col-xs-12 text-right">
                    <submit-button></submit-button>
                </div>
            </div>
    </div>
</template>

<script>
    require('../../../vendor/jquery/plugins/diff_match_patch/javascript/diff_match_patch')
    require('../../../vendor/jquery/plugins/preetyTextDiff/jquery.pretty-text-diff.min')
    let _ = require('lodash')
    let toastr = require('toastr')

    export default {
        props: [
            'originalCuesJson',
            'correctedCuesJson',
            'translatedCuesJson',
            'changedCuesJson',
        ],

        data: function() {
            return {

            }
        },

        computed: {
            originalCues: function() {
                return JSON.parse(this.originalCuesJson)
            },
            correctedCues: function() {
                return JSON.parse(this.correctedCuesJson)
            },
            translatedCues: function() {
                return JSON.parse(this.translatedCuesJson)
            },
            changedCues: function() {
                return JSON.parse(this.changedCuesJson)
            },
        },

        methods: {
            isLocked: function(cueNumber) {
                return this.changedCues.indexOf(cueNumber) === -1
            },
        },
    }
</script>
